import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import { IdParams } from 'types/api'
import { ITenderInstruction } from 'types/tender/tenderInstructions'

export const tenderInstructionsApi = createApi({
  reducerPath: 'tenderInstructions',
  baseQuery,
  endpoints: (builder) => ({
    tenderInstructions: builder.query<ITenderInstruction[], void>({
      query: () => ({
        url: '/tender-instructions',
      }),
    }),

    tenderInstructionCurrent: builder.query<ITenderInstruction, void>({
      query: () => ({
        url: '/tender-instructions/current',
      }),
    }),

    tenderInstruction: builder.query<ITenderInstruction, IdParams>({
      query: ({ id }) => `/tender-instructions/${id}`,
    }),

    createTenderInstruction: builder.mutation<
      ITenderInstruction,
      Partial<ITenderInstruction>
    >({
      query: (body) => ({
        url: '/tender-instructions',
        body,
        method: 'post',
      }),
    }),

    updateTenderInstruction: builder.mutation<
      ITenderInstruction,
      Partial<ITenderInstruction>
    >({
      query: (body) => ({
        url: `/tender-instructions/${body.id}`,
        body,
        method: 'put',
      }),
    }),

    deleteTenderInstruction: builder.mutation<void, IdParams>({
      query: ({ id }) => ({
        url: `/tender-instructions/${id}`,
        method: 'delete',
      }),
    }),
  }),
})

export const {
  useTenderInstructionQuery,
  useTenderInstructionCurrentQuery,
  useTenderInstructionsQuery,
  useCreateTenderInstructionMutation,
  useUpdateTenderInstructionMutation,
  useDeleteTenderInstructionMutation,
} = tenderInstructionsApi
